<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            
           <div class="row mb-md-4 align-items-center form-header">
            <div class="col mt-4 d-none d-sm-block" >
              <h4 class="ms-lg-4 ms-md-2">View CA Payment Details</h4>
            </div>
            <div class="col mt-4 d-block  d-sm-none">
                <h5>View CA Payments</h5>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                 Back To CA Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
           
              <div class="col-lg-8 col-md-12 col-sm-6 m-lg-4 m-md-2">
                <div class="card p-4">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Name:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.name"
                        disabled
                      />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Mobile:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.mobile"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Address:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.address"
                        disabled
                      />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Pan Number:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.pan"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Amount:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.amount"
                        disabled
                      />
                    </div>
                  
                  </div>
                   <h5 class="mt-2 fw-bold bank-details">Bank Info</h5>
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                  <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Account Number:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.accountNumber"
                        disabled
                      />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Account Holder Name:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.accountHolderName"
                        disabled
                      />
                    </div>
                   
                 
                  </div>
                  <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Bank Name:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.bankName"
                        disabled
                      />
                    </div>
                       <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>IFSC Code:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.IfscCode"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Branch:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="donation.branch"
                        disabled
                      />
                    </div>
                  </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
          </div>
        </div>
      </div>
    </template>
  </llp-page>
   <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";

export default {
  data() {
    return {
      donation: {
        name: "",
        mobile: "",
        address: "",
        pan: "",
        amount: "",
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IfscCode:'',
         branch:"",
      },
        serviceId: this.$route.params.serviceId,
      itemId:this.$route.params.id,
      userId: localStorage.getItem("User_id"),
       userDetails:[],
    };
  },
  mounted() {
    this.fetchingCaRelatedDetails();
    
  },
  methods: {
    BackToServices() {
      this.$router.back();
    },
   async fetchingCaRelatedDetails()
   {
 try {
        const caRelatedResponse = await NetworkService.get(`/get-service-list-edit/${this.itemId}/${this.userId}/${this.serviceId}`);
        this.userDetails = caRelatedResponse.details;
        this.donation.name = this.userDetails.name;
        this.donation.mobile = this.userDetails.mobile;
        this.donation.pan = this.userDetails.pan_number ? "*".repeat(this.userDetails.pan_number.length - 4) + this.userDetails.pan_number.slice(-4) : "";
        this.donation.address = this.userDetails.address;
        this.donation.accountHolderName = this.userDetails.account_holder_name;
        this.donation.accountNumber=this.userDetails.account_number;
        this.donation.bankName=this.userDetails.bank_name;
        this.donation.IfscCode = this.userDetails.ifsc_code;
        this.donation.amount = this.userDetails.amount;
        this.donation.branch = this.userDetails.bank_branch;
      } catch (error) {
        if(error.message){
          this.$refs.toast.show(error.message,"error")
        }else{
          this.$refs.toast.show(
              "Unable to fetching the ca related payment details",
              "error"
            );
        }
      }
   }
  },
};
</script>
